<div class="mx-auto max-w-7xl px-2 py-5 sm:px-6 lg:px-8">
  <div class="mx-auto grid grid-cols-1 grid-rows-1 items-start lg:mx-0 lg:grid-cols-12">
    <ng-content></ng-content>
  </div>
</div>
